import styled from 'styled-components';
import { vars } from 'utils/variables';

export const DividerLine = styled.div`
  width: 100%;
  height: 1px;

  background-color: ${vars.darkTransparent20};
`;
